import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';

import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';

@Injectable({ providedIn: 'root' })
export class NavigationHelper {
    private router = inject(Router);

    private firstLoadFlag = 2;

    constructor() {
        const productUtils = inject(SportsProductUtils);

        this.router.events.pipe(productUtils.filterSports(), takeUntilDestroyed()).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.navigationEnded(event);
            }
        });
    }

    private navigationEnded(event: NavigationEnd): void {
        if (this.firstLoadFlag) {
            this.firstLoadFlag--;
        }

        const isAddBetsRoute = event && event.url.toLowerCase().includes('addbets');

        if (isAddBetsRoute && this.firstLoadFlag) {
            // we're initializing the app on the addBets route and might open the betslip popup
            // don't allow back;
            this.firstLoadFlag = 2;
        }

        if (event && event.url.includes('labelhost')) {
            this.firstLoadFlag = 2;
        }
    }

    forceHomePage(): boolean {
        return this.firstLoadFlag === 1;
    }

    allowBack(): boolean {
        return !this.firstLoadFlag;
    }
}
